module.exports = __webpack_public_path__ + "759c0b57dc72d2667d1d614d0cc4eb99.svg";